import classLogo from "../images/BOOKR-Class-logo.svg";
import styles from "./Navbar.module.css";
import searchIcon from "../images/search.png";
import searchSelectedIcon from "../images/search-selected.svg";
import React from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import LevelSelector from "./LevelSelector";
import ProfileDashboardButton from "./ProfileDashboardButton";
import { isVietnamHost } from "../utils/host.js";

const VN_HOST = "https://bookrclass.go.vn";

function Navbar({ hideSearch, hideLevelSelector = true }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isVietnamHostValue = isVietnamHost();
  const isHomeScreen = location.pathname === "/" && !searchParams.has("book");

  const handleClickLogo = () => {
    // MUST stay as-is (internal navigation depends on it)
    navigate("/", { replace: false });
  };

  const handleClickBack = () => {
    window.location.href = VN_HOST;
    return null;
  };

  const handleClickSearch = () => {
    searchParams.delete("book");
    navigate("/search?" + searchParams.toString(), { replace: false });
  };

  return (
    <div className={styles.bg_class}>
      <nav className={styles.navbar}>
        {isVietnamHostValue && isHomeScreen && (
          <button
            type="button"
            className={styles.backButton}
            onClick={handleClickBack}
            aria-label="Back to home"
          >
            <svg className={styles.backIcon} viewBox="0 0 24 24" aria-hidden="true">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
        )}

        <div
          className={`${styles.logo} ${isVietnamHostValue ? styles.logoWithBack : ""}`}
          onClick={handleClickLogo}
        >
          <img src={classLogo} width="90" height="43" alt="BOOKR Class" />
        </div>

        <div className={styles.level} hidden={hideLevelSelector}>
          <LevelSelector />
        </div>

        <div className={styles.login}>
          <ProfileDashboardButton />
        </div>

        <div className={styles.searchIcon} onClick={handleClickSearch}>
          <img
            src={hideSearch ? searchSelectedIcon : searchIcon}
            alt="searchIcon"
          />
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
